var html = '<div class="modal">' +
    '<div class="modal__mask"></div>' +
    '<div class="modal__body js-body"></div>' +
'</div>';

function Modal (body) {
    this.$el = $(html);
    this.$body = $(body);
    this.$body.show();
    this.$el.find('.js-body').append(this.$body);
    $('.wrap').append(this.$el);

    this.$el.on('click', '.js-close', $.proxy(function () {
        this.close();
    }, this));
}

Modal.prototype = {
    constructor: Modal,
    open: function () {
        this.$el.show();
        this.$el.find('.js-body').css({
            top: $(window).scrollTop() + $(window).height() / 2 - this.$body.outerHeight() / 2
        });
    },
    close: function () {
        this.$el.fadeOut();
    }
}

module.exports = Modal;


//////////////////
// WEBPACK FOOTER
// ./pages/new/js/modal.js
// module id = 1
// module chunks = 0